import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  droppableMenuItemOption: {
    flexGrow: 1,
    // minHeight: "72px",
    transition: 'background-color 200ms ease',

    '&.dragging-over': {
      backgroundColor: '#eff2f3',
    },
  },
  boxLabel: {
    backgroundColor: '#fff',
    padding: '0px 0.5rem',
  },
  boxOutlined: {
    borderColor: 'rgba(0, 0, 0, 0.23)',
    border: '1px solid rgba(0,0,0,.23)',
    borderRadius: '4px',
    marginTop: '1rem',
    paddingLeft: '1px',
    paddingRight: '1px',
    position: 'relative',
    '&:hover': {
      borderColor: 'rgba(0, 0, 0, 0.87)',
    },
    // "&:active": {
    //   borderColor: theme.palette.primary.main,
    // },
  },
}));

export default useStyles;
